import React, {Component} from "react";
import PropTypes from 'prop-types';
import {getResponsiveStyles} from "./../../cc-imports";

// import './gradient-btn.css'
// import './gradient-btn-320x720.css'
import './../../styles/css/components/CCLGButton/cc-lg-button.css'

class CCLGButton extends Component {

    constructor(props) {
        super(props)
    }

    static propTypes = {
        title: PropTypes.string.isRequired,
        textStyles: PropTypes.oneOfType([
            PropTypes.array,
            PropTypes.number,
            PropTypes.shape({}),
        ]),
        onPress : PropTypes.func,
        buttonStyles: PropTypes.oneOfType([
            PropTypes.array,
            PropTypes.number,
            PropTypes.shape({}),
        ]),
    }
    static defaultProps = {
        gradient: false,
        start: {},
        end: {},
        locations: [],
        colors: [],
        onPress : ()=>{}
    }

    render() {
        const {style,textStyles, buttonStyles, title, colors} = this.props;
        const styles = ccStyles.default;
        return (
            <button onClick={this.props.onPress} className={'gradient-button btn '+ this.props.className+' '+(this.props.completed?'gradient-button-disabled':'')} style={style}>{title}</button>
        );
    }
}


const ccStyles = {
    default : {
        buttonStyles: {
            width: 100,
            borderRadius: 25
        },
        textStyles: {
            alignSelf: 'center',
            color: '#020202',
            fontSize: 16,
            fontWeight: '900',
            paddingTop: 10,
            paddingBottom: 10
        }
    },
    s : {
        buttonStyles: {
            width: 80,
            borderRadius: 25
        },
        textStyles: {
            fontSize: 14,
        }
    }
}
export default CCLGButton


// WEBPACK FOOTER //
// ./src/app/components/CCLGButton/CCLGButton.js